import AsyncStorageCache from "../AsyncStorageCache";
import { LocalCacheInterface } from "../Interfaces/GlobalInterfaces";
import LocalStorage from "../LocalStorage";
import ServerSideCache from "../ServerSideCache";

export default class LocalCacheInstanceFactory {
  public createLocalCacheInstance = (idSchema: string): LocalCacheInterface => {
    if (typeof window === "undefined") {
      return ServerSideCache.getInstance(idSchema);
    }

    // Ugly hack, but the normal way to check if any JS code is running in
    // React Native is to check product.navigator, but that is deprecated.
    // The __DEV__ global variable are set by RN in iOS and Android environments.
    // More info: https://stackoverflow.com/questions/33264431/react-native-dev-and-prod-variables
    //@ts-ignore
    if (typeof __DEV__ !== "undefined") {
      return AsyncStorageCache.getInstance(idSchema);
    }

    return LocalStorage.getInstance(idSchema);
  };
}
